import { createStructuredSelector } from 'reselect'
import { userInfo, isUserLoggedIn, needsReauth } from '../redux/selectors/auth'
import { isConnected } from '../redux/selectors/connectivity'
import { watchConnectivityThunk } from '../redux/thunks/connectivity'
import AuthRedux from '../redux/auth'

export const mapStateToProps = createStructuredSelector({
  isUserLoggedIn,
  userInfo,
  isConnected,
  needsReauth,
})

export const mapDispatchToProps = {
  loginSuccess: AuthRedux.loginSuccess,
  watchConnectivity: watchConnectivityThunk,
}
